// extracted by mini-css-extract-plugin
export default {"row":"MunicipalityBuildingLoadingRow_row__0IIe0","buildingName":"MunicipalityBuildingLoadingRow_buildingName__zUboB","chart":"MunicipalityBuildingLoadingRow_chart__oTCAu"};